(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["multi-level-category"] && !Shopify.designMode) return;
  try {
    var first = true;

  function getCategories(root) {
    var result = [];
    var lis = root.querySelectorAll(':scope > li');
    lis.forEach(function (li) {
      var link = li.querySelector(':scope > a');
      var childrenUl = li.querySelector(':scope > ul');
      var node = {
        link: link ? link.getAttribute('href') : '',
        title: link ? link.innerHTML : '',
        children: childrenUl ? getCategories(childrenUl) : [],
      };
      result.push(node);
    });
    return result;
  }

  function setActive() {
    var result = [];
    var curLi = document.querySelector('nav#navPages > ul .active');
    if (!curLi || curLi.parentElement == null) return false;
    var index = Array.from(curLi.parentElement.children).indexOf(curLi);
    if (index === -1) return false;
    result.push(index);

    curLi = curLi.parentElement.parentElement;
    if (curLi && curLi.id !== 'navPages') {
      index = Array.from(curLi.parentElement.children).indexOf(curLi);
      result.push(index);
      curLi = curLi.parentElement.parentElement;
      if (curLi && curLi.id !== 'navPages') {
        index = Array.from(curLi.parentElement.children).indexOf(curLi);
        result.push(index);
      }
    }
    return result;
  }

  function buildSelect(level, level_List) {
    for (var i = level; i <= 4; i++) {
      var ul = document.querySelector('#multi-category_select-level-' + i + ' ul');
      if (ul) {
        ul.querySelectorAll('li[data-value]').forEach((li) => li.remove());
      }
    }
    var container = document.querySelector('#multi-category_select-level-' + level + ' ul');
    if (!container) return;
    for (var i = 0; i < level_List.length; i++) {
      var li = document.createElement('li');
      li.setAttribute('data-value', i);
      li.textContent = level_List[i].title.trim();
      li.addEventListener(
        'click',
        (function (lvl, idx) {
          return function () {
            changeOption(lvl, idx);
          };
        })(level, i)
      );
      container.appendChild(li);
    }
  }

  function changeOptionAll(level) {
    var ul = document.querySelector('#multi-category_select-level-' + level + ' ul');
    if (!ul) return;
    ul.querySelectorAll('li').forEach((li) => li.classList.remove('active'));
    var select_option = ul.querySelector('li:nth-child(1)').innerHTML;
    var label = document.querySelector('#multi-category_select-level-' + level).previousElementSibling;
    label.innerHTML = select_option;
  }

  function changeOption(level, num) {
    if (num != null) {
      var redirect = false;
      var selector = '#multi-category_select-level-' + level + ' ul li[data-value="' + num + '"]';
      var activeLi = document.querySelector(selector);
      if (activeLi && !activeLi.classList.contains('active')) {
        redirect = true;
      }
      var ul = document.querySelector('#multi-category_select-level-' + level + ' ul');
      ul.querySelectorAll('li').forEach((li) => li.classList.remove('active'));
      ul.querySelectorAll('li').forEach(function (li) {
        if (li.getAttribute('data-value') == num) {
          li.classList.add('active');
          document.querySelector('#multi-category_select-level-' + level).previousElementSibling.textContent =
            li.textContent;
        }
      });

      resetDrop(level);

      var level_List = list;
      for (var i = 1; i <= level; i++) {
        var active = document.querySelector('#multi-category_select-level-' + i + ' ul .active');
        if (active) {
          var index = parseInt(active.getAttribute('data-value'));
          if (level_List[index] !== undefined) {
            level_List = level_List[index].children;
          }
        }
      }

      if (level == 3 && redirect == true) {
        document.querySelector('#multi-category_select-browse').click();
      }

      level = parseInt(level) + 1;
      buildSelect(level, level_List);

      if (level_List.length && first == false) {
        var loading = document.querySelector('.multi-category_filter .loading');
        loading.style.display = 'block';
        setTimeout(function () {
          document.querySelector('#multi-category_select-level-' + level).classList.add('open');
          loading.style.display = 'none';
        }, 300);
      }
    }
  }

  function resetDrop(num) {
    for (var i = num + 1; i <= list.length; i++) {
      var ul = document.querySelector('#multi-category_select-level-' + i + ' ul');
      if (!ul) continue;
      var select_option = ul.querySelector('li:nth-child(1)') ? ul.querySelector('li:nth-child(1)').innerHTML : '';
      var label = document.querySelector('#multi-category_select-level-' + i).previousElementSibling;
      label.innerHTML = select_option;
      ul.innerHTML = '<li onclick="changeOptionAll(' + i + ')">' + select_option + '</li>';
    }
  }

  var list = getCategories(document.querySelector('nav#navPages > ul'));

  function MultiCategory() {
    if (!document.querySelector('.multi-category')) {
      return;
    }

    buildSelect(1, list);

    var level = 1;
    document.cookie = 'multiLevelCategory=; path=/;';

    var cookie = document.cookie.split('; ').find((row) => row.startsWith('multiLevelCategory='));
    if (cookie && cookie.split('=')[1] != '') {
      var active = cookie.split('=')[1].split(',');
      for (var i = 0; i < active.length; i++) {
        changeOption(level, active[i]);
        level++;
      }
      document.querySelector('.multi-category_filter .loading').style.display = 'none';
      document.querySelectorAll('.dropdown-up').forEach((el) => el.classList.remove('open'));
    }

    document.addEventListener('click', function (e) {
      if (e.target.classList.contains('da-force-up')) {
        var dropdown = e.target.parentElement.querySelector('.dropdown-up');
        var isOpen = dropdown.classList.contains('open');
        document.querySelectorAll('.dropdown-up').forEach((el) => el.classList.remove('open'));
        if (!isOpen) dropdown.classList.add('open');
      }
    });

    window.addEventListener('click', function (e) {
      var container = document.querySelectorAll('.da-force-up');
      container.forEach(function (el) {
        if (el !== e.target && !el.contains(e.target)) {
          var dropdown = el.nextElementSibling;
          if (dropdown && dropdown.classList.contains('dropdown-up')) {
            dropdown.classList.remove('open');
          }
        }
      });
    });

    document.querySelector('#multi-category_select-browse').addEventListener('click', function () {
      var level_List = list;
      var index = 0,
        url = '';
      var menu = [];
      for (var i = 1; i <= 3; i++) {
        var active = document.querySelector('#multi-category_select-level-' + i + ' ul .active');
        if (active) {
          index = parseInt(active.getAttribute('data-value'));
          if (!isNaN(index)) {
            menu.push(index);
            url = level_List[index].link;
            if (level_List[index].children.length) {
              level_List = level_List[index].children;
            }
          }
        }
      }
      document.cookie = 'multiLevelCategory=' + menu.join(',') + '; path=/; max-age=' + 60 * 60 * 24;
      location.href = url;
    });

    document.querySelector('#multi-category_clear-select').addEventListener('click', function () {
      resetDrop(1);
      var ul = document.querySelector('#multi-category_select-level-1 ul');
      var select_option = ul.querySelector('li:nth-child(1)').innerHTML;
      document.querySelector('#multi-category_select-level-1').previousElementSibling.innerHTML = select_option;
      ul.querySelectorAll('li').forEach((li) => li.classList.remove('active'));
    });

    first = false;
  }

  window.addEventListener('load', () => {
    MultiCategory();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["social-share-button"] && !Shopify.designMode) return;
  try {
    class ShareButtonProduct extends HTMLElement {
    constructor() {
      super();

      this.elements = {
        shareButton: this.querySelector('button'),
        successMessage: this.querySelector('[id^="ShareMessage"]'),
        urlInput: this.querySelector('input'),
        content: this.querySelector('.share-button__product'),
        copyButton: this.querySelector('.button-copy')
      };

      if (this.elements.shareButton) {
        this.elements.shareButton.addEventListener('click', this.toggleDetails.bind(this));
      }
      if (this.elements.copyButton) {
        this.elements.copyButton.addEventListener('click', this.copyToClipboard.bind(this));
      }
    }

    toggleDetails(event) {
      event?.preventDefault && event.preventDefault();
      event?.stopPropagation && event.stopPropagation();
      if (!this.elements.urlInput) return;

      const url = this.elements.urlInput.getAttribute('data-url');

      this.setProductInfoTop(this.getProductInfoPosition());

      if (this.elements.successMessage) {
        this.elements.successMessage.classList.add('hidden');
      }
      this.elements.urlInput.setAttribute('value', url);
      this.elements.urlInput.classList.remove('is-copy');
    }

    copyToClipboard(event) {
      event?.preventDefault && event.preventDefault();
      event?.stopPropagation && event.stopPropagation();

      if (!this.elements.urlInput || this.elements.urlInput.classList.contains('is-copy')) return;

      navigator.clipboard.writeText(this.elements.urlInput.value).then(() => {
        if (this.elements.successMessage) {
          this.elements.successMessage.setAttribute('aria-hidden', false);
        }
        this.elements.urlInput.setAttribute('value', 'Link copied to clipboard!');
        this.elements.urlInput.classList.add('is-copy');

        setTimeout(() => {
          if (this.elements.successMessage) {
            this.elements.successMessage.setAttribute('aria-hidden', true);
          }
        }, 6000);
      });
    }

    closeDetails(event) {
      event?.preventDefault && event.preventDefault();
      if (!this.elements.urlInput) return;
      const url = this.elements.urlInput.getAttribute('data-url');

      if (this.elements.successMessage) {
        this.elements.successMessage.classList.add('hidden');
      }
      this.elements.urlInput.setAttribute('value', url);
      this.elements.urlInput.classList.remove('is-copy');
      this.setProductInfoTop(0);
    }

    getProductInfoPosition() {
      const stickyElement = document.querySelector('.productView-details');
      if (!stickyElement || !stickyElement.parentNode) return 0;

      const stickyRect = stickyElement.getBoundingClientRect();
      const parentRect = stickyElement.parentNode.getBoundingClientRect();

      const topOffset = stickyRect.top - parentRect.top;
      return topOffset;
    }

    setProductInfoTop(top) {
      const productDetails = document.querySelector('.productView-details');
      if (productDetails && productDetails.style) {
        productDetails.style.setProperty('--sticky-top', top + 'px');
      }
    }
  }

  if (!customElements.get('share-button-product')) {
    customElements.define('share-button-product', ShareButtonProduct);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["spo-acc-head"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('spo-accordion')) {
    class SpoAccordion extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('.spo-acc__button');
        this.panel = this.button && document.getElementById(this.button.getAttribute('aria-controls'));
        if (!this.panel) return;
        this.button.addEventListener('click', () => this.setOpen(this.button.getAttribute('aria-expanded') !== 'true', true));
        // Browser find-in-page / text-fragment match inside a hidden="until-found" panel.
        this.panel.addEventListener('beforematch', () => this.setOpen(true));
      }

      /** @param {boolean} open @param {boolean} [animate] */
      setOpen(open, animate) {
        if (!this.panel) return;
        this.button.setAttribute('aria-expanded', String(open));
        this.toggleAttribute('data-open', open);
        if (open) {
          this.panel.removeAttribute('hidden');
          if (animate) {
            this.classList.add('gtx-opening');
            window.setTimeout(() => this.classList.remove('gtx-opening'), 400);
          }
          this.dispatchEvent(new CustomEvent('spo:accordion-open', { bubbles: true }));
        } else {
          this.panel.setAttribute('hidden', 'until-found');
        }
      }
    }
    customElements.define('spo-accordion', SpoAccordion);

    // #anchor links (e.g. "All specifications", a #faq URL) open the section they point into, then scroll.
    const openFor = (hash) => {
      if (!hash || hash.length < 2) return false;
      let target = null;
      try {
        target = document.querySelector(hash);
      } catch (error) {
        return false;
      }
      const accordion = target && target.closest('spo-accordion');
      if (!accordion || typeof accordion.setOpen !== 'function') return false;
      accordion.setOpen(true);
      return true;
    };
    document.addEventListener('click', (event) => {
      const link = event.target instanceof Element && event.target.closest('a[href^="#"]');
      if (link) openFor(link.getAttribute('href'));
    }, true);
    window.addEventListener('hashchange', () => openFor(location.hash));
    const initial = () => {
      if (openFor(location.hash)) document.querySelector(location.hash)?.scrollIntoView();
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initial, { once: true });
    else initial();
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["spo-pdp-review-summary"] && !Shopify.designMode) return;
  try {
    /* PDP reviews (polish 2 14/10, #51 item 3): "Read more" for review bodies clamped to 3 lines, and the first
     "Show more reviews" press reveals the reviews hidden by the 4 / 3 cap. Judge.me renders and re-renders its
     list (load more, filters, sort), so new items are picked up with a MutationObserver. Theme side only. */
  (() => {
    const panel = document.querySelector('.spo-pdp-panel--reviews');
    if (!panel) return;

    /** @param {Element} wrap */
    const addMore = (wrap) => {
      if (wrap.dataset.spoMore || wrap.dataset.jdgmTruncated === 'true') return;
      const body = wrap.querySelector('.jm-review-content__body');
      if (!body) return;
      // Overflow of at least half a line of the review text itself (its <p> sets the real line height). Hidden
      // items (beyond the 4 / 3 cap) measure 0 and are checked again when they are revealed.
      const text = body.querySelector('p') || body;
      const line = parseFloat(getComputedStyle(text).lineHeight) || 17;
      if (body.clientHeight === 0 || body.scrollHeight - body.clientHeight < line / 2) return;
      wrap.dataset.spoMore = '1';
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'spo-rev-more';
      btn.textContent = 'Read more';
      btn.setAttribute('aria-expanded', 'false');
      btn.addEventListener('click', () => {
        const open = wrap.classList.toggle('spo-rev-open');
        btn.textContent = open ? 'Read less' : 'Read more';
        btn.setAttribute('aria-expanded', String(open));
      });
      wrap.after(btn);
    };

    let queued = false;
    // PDP B (build 4): names without Judge.me's stray "(." suffix; dates as "18 Aug 2026"; the bullet before the
    // date marked so CSS hides it with the flag. Text only, nothing else is changed.
    const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const tidy = (item) => {
      if (item.dataset.spoTidy) return;
      item.dataset.spoTidy = '1';
      const name = item.querySelector('.jm-reviewer-info__name');
      if (name) name.textContent = name.textContent.replace(/\s*\(\.?\s*$/, '').trim();
      for (const span of item.querySelectorAll('.jm-reviewer-info__details span.jm-text')) {
        const t = span.textContent.trim();
        const m = t.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
        if (m && +m[2] >= 1 && +m[2] <= 12) span.textContent = `${+m[1]} ${MONTHS[+m[2] - 1]} ${m[3]}`;
        else if (t === '•') span.classList.add('spo-rev-dot');
      }
    };
    const scan = () => {
      queued = false;
      for (const wrap of panel.querySelectorAll('.jm-review-body-wrapper')) addMore(wrap);
      for (const item of panel.querySelectorAll('.jm-review-item')) tidy(item);
    };
    const queue = () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(scan);
    };
    new MutationObserver(queue).observe(panel, { childList: true, subtree: true, attributeFilter: ['class'] });
    queue();
    document.fonts?.ready.then(queue);

    panel.addEventListener(
      'click',
      (event) => {
        if (event.target instanceof Element && event.target.closest('.jm-load-more-pagination button')) {
          panel.classList.add('spo-rev-all');
        }
      },
      true
    );
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["spo-pdp-sticky"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('spo-sticky-buy')) {
    class SpoStickyBuy extends HTMLElement {
      connectedCallback() {
        if (this.parentElement !== document.body) {
          document.body.append(this);
          return;
        }
        if (this.ready) return;
        this.ready = true;
        this.mainButton = document.querySelector('.buy-buttons-block .product-form__submit');
        this.button = this.querySelector('.spo-sticky__atc');
        if (!this.mainButton || !this.button) return;
        this.button.addEventListener('click', () => this.mainButton.click());
        this.past = false;
        // A passive, rAF-throttled scroll check (not an IntersectionObserver: a jump to an anchor can skip
        // straight over the buy buttons without them ever intersecting, and the observer would not fire).
        this.watched = this.mainButton.closest('.product-form__buttons') || this.mainButton;
        let queued = false;
        this.onScroll = () => {
          if (queued) return;
          queued = true;
          window.requestAnimationFrame(() => {
            queued = false;
            const past = this.watched.getBoundingClientRect().bottom < 0;
            if (past !== this.past) {
              this.past = past;
              this.#update();
            }
          });
        };
        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.onScroll();
        // The cookie banner has no close event of its own; check until it has gone.
        document.addEventListener('visitorConsentCollected', () => window.setTimeout(() => this.#update(), 300));
        this.timer = window.setInterval(() => {
          if (this.#bannerUp()) return;
          window.clearInterval(this.timer);
          this.#update();
        }, 1000);
      }

      disconnectedCallback() {
        window.clearInterval(this.timer);
        if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
      }

      #bannerUp() {
        const banner = document.getElementById('shopify-pc__banner');
        if (!banner) return false;
        const box = banner.getBoundingClientRect();
        return box.height > 0 && getComputedStyle(banner).visibility !== 'hidden' && getComputedStyle(banner).display !== 'none';
      }

      #update() {
        const show = this.past && !this.#bannerUp();
        if (show) {
          this.button.disabled = this.mainButton.disabled;
          const label = this.mainButton.textContent.trim();
          if (label) this.button.textContent = label;
        }
        this.classList.toggle('is-visible', show);
        document.documentElement.classList.toggle('spo-sticky-on', show);
      }
    }
    customElements.define('spo-sticky-buy', SpoStickyBuy);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["spo-popular-head"] && !Shopify.designMode) return;
  try {
    (() => {
    for (const head of document.querySelectorAll('[data-spo-popular-head]')) {
      const section = head.closest('.shopify-section');
      const link = head.querySelector('[data-spo-tab-link]');
      const label = link?.querySelector('.spo-home-more__label');
      const mapEl = head.querySelector('[data-spo-tab-map]');
      if (!section || !link || !label || !mapEl) continue;
      /** @type {{url: string, label: string}[]} */
      const map = JSON.parse(mapEl.textContent);
      const triggers = () => Array.from(section.querySelectorAll('.tabs-component-panel-trigger'));
      const sync = () => {
        const index = triggers().findIndex((trigger) => trigger.classList.contains('--active'));
        const entry = map[index];
        if (!entry || !entry.url) return;
        link.href = entry.url;
        label.textContent = entry.label;
      };
      section.addEventListener('click', (event) => {
        if (event.target instanceof Element && event.target.closest('.tabs-component-panel-trigger')) {
          window.requestAnimationFrame(sync);
        }
      });
      const header = section.querySelector('.tabs-component-panel-trigger')?.parentElement;
      if (header) new MutationObserver(sync).observe(header, { subtree: true, attributes: true, attributeFilter: ['class'] });
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
